import { z } from 'zod'
import { uploadFileDataSchema } from '~library/models'

const exclusiveOfferFileSchema = z.object({
  ...uploadFileDataSchema.shape,
  /** 首圖 */
  index: z.boolean(),
  /** 圖片文字描述 */
  description: z.string()
})

export const exclusiveOfferContentSchema = z.object({
  /** 商品名稱 */
  name: z.string(),
  /** 檔案 */
  file: z.array(exclusiveOfferFileSchema),
  /** 適用地點 */
  applicableLocation: z.string(),
  /** 適用門市/地址 */
  applicableStore: z.string(),
  /** 優惠內容 */
  offerDetails: z.string(),
  /** 兌換方式 */
  exchangeMethod: z.string(),
  /** 網址替代文字 */
  urlAltText: z.string(),
  /** 網址 */
  url: z.string(),
  /** 其他說明 */
  remark: z.string(),
  /** 影片網址 */
  mediaURL: z.string()
})

export interface ExclusiveOfferContent
  extends z.infer<typeof exclusiveOfferContentSchema> {}
